import { useEffect, useState } from 'react';
import { loadProfiles, getProfileByName, SearchProfile } from '../services/live-search';

type ProfilesState = [SearchProfile[]?, SearchProfile?];
export type ProfilesReturn = [SearchProfile[] | undefined, SearchProfile | undefined, (profile: SearchProfile) => void];

export default function useSearchProfiles(searchType: string, profileName?: string | null): ProfilesReturn {
    const [profiles, setProfiles] = useState<ProfilesState>([undefined, undefined]);

    function setProfile(profile: SearchProfile) {
        // console.info('useSearchProfiles.setProfile:', profile);
        setProfiles((prev: ProfilesState) => {
            return [prev[0], profile];
        });
    }

    // console.info('useSearchProfiles:', profileName);
    useEffect(() => {
        // console.info('  loading profiles for useSearchProfiles');
        return loadProfiles(searchType, newProfiles => {
            const profile = getProfileByName(searchType, profileName);
            // console.info('requested profile:', profile);
            setProfiles([newProfiles, profile]);
        });
    }, []);

    return [profiles[0], profiles[1], setProfile];
}
